import React from 'react'
import PropTypes from 'prop-types'
import ChevronDownIcon from '../icons/ChevronDownIcon'

const BASE_CLASSES = 'tw:flex tw:items-center tw:px-2'

const DropdownIndicator = ({ innerProps, isDisabled }) => (
  <span
    {...innerProps}
    className={`${BASE_CLASSES} ${isDisabled ? 'tw:text-gray-300' : 'tw:text-gray-500'}`}
  >
    <ChevronDownIcon className="tw:h-5 tw:w-5" />
  </span>
)

DropdownIndicator.propTypes = {
  innerProps: PropTypes.shape({
    onMouseDown: PropTypes.func,
    onTouchEnd: PropTypes.func
  }),
  isDisabled: PropTypes.bool
}

DropdownIndicator.defaultProps = {
  innerProps: null,
  isDisabled: false
}

export default DropdownIndicator
